module.exports = __webpack_public_path__ + "static/media/cartoes_diners.04720a0e.svg";